<template>
  <div ref="control" class="controlItem form-group mb-1" :class="control.className">
    <component
      v-if="show"
      :is="controlInstance"
      :control="controlObj"
      :label-position="labelPosition"
      :rowData="rowData"
      :gridId="gridId"
    />
  </div>
</template>

<script>
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'
import { CONTROL_TYPES } from '@/components/DataGrid/FormBuilder/config/control_constant'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  name: 'ControlComponent',
  props: ['control', 'labelPosition', 'gridId'],
  data() {
    return {
      controlInstance: null,
      rowData: null,
      controlObj: this.control,
    }
  },
  watch: {
    control: {
      deep: true,
      handler(newControl) {
        this.controlObj = newControl
      },
    },
  },
  computed: {
    show() {
      const rowData = this.rowData

      if (!this.control.vif) return true

      return eval(this.control.vif)
    },
  },
  methods: {
    blinkControl() {
      setTimeout(() => {
        $(this.$refs.control).addClass('item-highlight')

        setTimeout(() => {
          $(this.$refs.control).removeClass('item-highlight')
        }, 2000)
      })
    },
    dgCellChanged(cellKey, value) {
      if (cellKey !== this.control.propName) return

      this.controlObj = Object.assign({}, this.control, { value })

      this.blinkControl()
    },
  },
  created() {
    if (!CONTROL_TYPES[this.control.type]) {
      console.error(
        `Control type ${this.control.type} doesn't exist to render.`
      )
      return
    }

    Hooks.Control.beforeRegister.run(this.control)

    // set control
    this.controlInstance = CONTROL_TYPES[this.control.type].source.gui

    this.$nextTick(() => {
      const fbInst = this.$instByClass(this, 'form-builder-root')

      this.rowData = fbInst.rowData

      fbInst.$on('dgCellChanged', this.dgCellChanged)
    })
  },
  mounted() {
    Hooks.Control.afterRegister.run(this.control)
  },
}
</script>

<style lang="scss">
@keyframes yellowfade {
  from {
    background: yellow;
    border-radius: 5px;
  }
  to {
    background: transparent;
    border-radius: 5px;
  }
}

.controlItem.item-highlight {
  > *,
  input,
  textarea {
    animation: yellowfade 2s;
  }
}
</style>
